import { render, staticRenderFns } from "./toast.vue?vue&type=template&id=5856bac3&scoped=true&lang=html&"
import script from "./toast.vue?vue&type=script&lang=js&"
export * from "./toast.vue?vue&type=script&lang=js&"
import style0 from "./toast.vue?vue&type=style&index=0&id=5856bac3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5856bac3",
  null
  
)

export default component.exports